import { useState } from "react";
import { BackArrow, CloseIcon, Logo } from "./icons";
import Stage from "./components/Stage";
import useTest from "./hooks/use-test";
import Results from "./components/Results";
import Footer from "./components/Footer";
import LoadingSpinner from "./components/LoadingSpinner";
import Intro from "./components/Intro";

export default function Test({ testId }) {
    // The current step of the test, used to show progress bars and
    // conditionally render elements
    const [step, setStep] = useState(0);
    // Array to hold the answers the user provides
    const [answers, setAnswers] = useState([]);
    // Total question steps, again used for progress/rendering
    const totalSteps = 6;

    // Back button in header
    const onBack = () => {
        if (step !== 0) {
            setStep(step - 1);
        }
    }

    // Store quiz answers when an answer button is clicked
    const onClick = (key, answer) => {

        // Allow the intro to bypass the question logic
        if (answer) {
            // Get the existing answers
            let updatedAnswers = answers;
            // Add the new answer
            updatedAnswers[key] = answer;

            // Update the answers array stored
            setAnswers(updatedAnswers);
        }

        // This is deliberately comparing 0-4 to 5 to ensure that
        // the 5th step - the results - displays as expected
        if (totalSteps !== step) {
            setStep(step + 1);
        }
    }

    // Fetch all data from the WP REST API
    const test = useTest({ id: testId });

    // Array to hold all questions/steps of the form
    const stages = [];
    if (test.data && test.data?.questions) {

        if (test.data.heading || test.data.content) {
            stages.push(<Intro content={test.data.content} heading={test.data.heading} onClick={onClick} />);
        }

        // Loop through all questions and set up the steps
        test.data.questions.map((question, index) => (
            stages.push(<Stage heading={`Question ${index + 1}`} onClick={onClick} question={question} stage={index} />)
        ));

        // Check we have at least one result answer, and if so add this to the end of the test
        if (test.data?.question_one_false) {
            stages.push(<Results answers={answers} results={test.data} ctaHeading={test.data?.cta_heading} ctaContent={test.data?.cta_content} ctaLinkOne={test.data?.link_one} ctaLinkTwo={test.data?.link_two} />)
        }
    }

    return (
        <div className="test">
            <div className="test__header">
                <div className="test__container">
                    <div className="test__row">
                        <div className="test__col test__col--left">
                            {step > 0 && (
                                <button className="test__back" onClick={() => onBack()} type="button">
                                    <BackArrow />
                                </button>
                            )}
                        </div>

                        <div className="test__col test__col--middle">
                            <Logo />
                        </div>

                        <div className="test__col test__col--right">
                            {test.data?.all_tests && (
                                <a className="test__all" href={test.data.all_tests}>
                                    <CloseIcon />
                                    Back to all tests
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>

            <div className="test__body">  
                {test?.isInitialLoading ? (
                    <LoadingSpinner />
                ) : (
                <>             
                    {stages[step]}
                    {(stages?.length > 0 && totalSteps > 0 && step !== 6 && step !== 0) && (
                        <div className="test__progress">
                            <span className="test__progress-bar" style={{ width: `${((step + 1) / totalSteps) * 100}%` }} />
                        </div>
                    )}
                    {step !== 6 && <Footer disclaimer={test?.data?.disclaimer} />}        
                </>      
                )}
            </div>
        </div>
    )
}